/**
 * Truncates a string and adds an ellipsis if it exceeds the specified limit.
 *
 * @param {string} string - The string to be truncated.
 * @param {number} limit - The maximum length of the string before truncation.
 * @return {string | null} - The truncated string with an ellipsis, or null if the input string is falsy.
 */
export default function ellipsis(string, limit) {
    let dots = "…";
    if (string) {
        if (string.length > limit) {
            string = string.substring(0, limit) + dots;
        }
        return string;
    }
    return null
};
